export { InfoProps } from './info.props';
export const name = "InfoComponent";
